<script setup lang="ts">
import type { PoolStationConnectorType } from '~/interfaces/station'
import type { PropType } from 'vue'

const props = defineProps({
    totalConnectorsCount: {
        type: Number,
        required: true
    },
    availableConnectorsCount: {
        type: Number,
        required: true
    },
    powerConnector: {
        type: Number,
        required: true
    },
    connectorType: {
        type: Object as PropType<PoolStationConnectorType | object>,
        required: true
    }
})

const LEGACY_URL = useRuntimeConfig().public.LEGACY_URL as string

const getConnectorImgUrl = computed(() => {
    const connectorType = props.connectorType as PoolStationConnectorType

    if (connectorType && connectorType?.id && connectorType?.icon) {
        return `${LEGACY_URL}/medias/v2/connector_types/icon/original/${connectorType.id}/${connectorType.icon}`
    }

    return ''
})

const getConnectorLabel = computed(() => {
    const connectorType = props.connectorType as PoolStationConnectorType

    if (connectorType && connectorType.label) {
        return connectorType.label
    }

    return ''
})
</script>

<template>
    <div class="w-full">
        <div class="flex">
            <img
                class="max-h-14"
                loading="lazy"
                :alt="getConnectorLabel"
                :src="getConnectorImgUrl"
            />
            <div class="flex flex-col justify-center align-middle w-full">
                <p class="text-1.5xxs text-gray-l-500">
                    {{ powerConnector }} kW
                </p>
                <p class="text-0.5xs text-gray-l-400">
                    <span class="font-semibold text-gray-l-700">
                        {{ availableConnectorsCount }}
                    </span>
                    <span>/{{ totalConnectorsCount }}</span>
                </p>
            </div>
        </div>
    </div>
</template>
